import React from "react";
import Link from "../Link";

export const BreadcrumbItemLink = ({ href, children, ...props }) => {
	return (
		<Link href={href} className="breadcrumbs__item-link" {...props}>
			{children}
		</Link>
	);
};

BreadcrumbItemLink.propTypes = {
	...Link.propTypes,
};

const BreadcrumbItem = ({ ...props }) => {
	return <span className="breadcrumbs__item" {...props} />;
};

export default BreadcrumbItem;
